export default (
  {
    $vs,
    title = 'Sukces',
    text = 'Operacja zakończyła się sukcesem',
    color = 'success',
    position = 'bottom-right',
  } = {},
) => {
  $vs.notify({
    title: title,
    text: text,
    color: color,
    position: position,
  });
}
